import { eventNames, CoreEvent } from '@carvana/core-events';
import { useCallback } from 'react';

import { makeEventName } from '../analytics/uiMetrics';
import useAnalyticEvent from './useAnalyticEvent';

const useAccountModal = (app: string, component: string) => {
  const { recordMoMetricsEvent } = useAnalyticEvent();
  const recordSignInEvent = useCallback(
    (eventName: string) => {
      eventName = makeEventName(eventName);
      const eventDetails = { eventName, eventTime: new Date() };
      recordMoMetricsEvent(eventDetails, { app, component });
    },
    [app, component]
  );

  const signIn = (handleSuccess?: Function, handleCancel?: Function) => {
    let authenticationSucceeded = false;

    const timeoutId = setTimeout(() => {
      if (!authenticationSucceeded) {
        recordSignInEvent('SignIn Cancelled');
        if (typeof handleCancel === 'function') {
          handleCancel();
        }
      }
    }, 500);

    CoreEvent.emit(eventNames.accountModal.open, {
      OnAuthenticatedSuccess: () => {
        authenticationSucceeded = true;
        
        clearTimeout(timeoutId);

        recordSignInEvent('SignIn Success');
        if (typeof handleSuccess === 'function') {
          handleSuccess();
        }

        CoreEvent.emit(eventNames.accountModal.close);
      },
      step: 'email-form',
      CallerIdentifier: 'ValueTracker'
    });
  };

  return { signIn };
};

export default useAccountModal;
